<template>
  <div>
    <!-- banner -->
    <div class="tw-mx-auto tw-text-center tw-text-black">
      <div class="tw-bg-light-gray tw-p-8">
        <img src="/images/icons/db-connection.svg" class="mx-auto" />
        <h1 class="tw-font-bold tw-text-xl tw-my-3">
          คุณยังไม่ได้เชื่อมต่อกับ e-commerce
        </h1>
        <p class="tw-my-0">สร้างร้านค้าของคุณเพื่อทำการเชื่อมต่อ</p>
      </div>
    </div>
    <!-- create shop form -->
    <div class="tw-max-w-xl tw-mx-auto tw-py-12">
      <shop-form :companyId="companyId"/>
    </div>
  </div>
</template>

<script>
import ShopForm from './shop-form.vue'

export default {
  name: 'ShopEmpty',
  components: {
    ShopForm,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
}
</script>